export default function About() {
  return (
    <section className="bg-[#faf8f5] py-20 px-5 sm:px-8 lg:px-16">
      <div className="max-w-5xl mx-auto">

        {/* Label */}
        <div className="flex items-center gap-3 mb-10">
          <div className="w-8 h-px bg-[#C9A84C]"></div>
          <span className="text-[#C9A84C] text-xs tracking-[0.25em] uppercase font-semibold" style={{ fontFamily: 'DM Sans, sans-serif' }}>
            Sobre a Especialista
          </span>
        </div>

        {/* Main grid */}
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">

          {/* Image */}
          <div className="w-full lg:w-2/5 flex-shrink-0">
            <div className="relative rounded-3xl overflow-hidden shadow-xl" style={{ aspectRatio: '3/4' }}>
              <img
                src="/img/IMG_8863.JPEG"
                alt="Dra. Leonida Fontoura"
                className="w-full h-full object-cover object-top"
              />
              {/* Gold frame accent */}
              <div className="absolute inset-0 rounded-3xl ring-1 ring-[#C9A84C]/20"></div>
              {/* CRM badge on image */}
              <div className="absolute bottom-5 left-5 right-5">
                <div className="bg-white/95 backdrop-blur-md border border-[#C9A84C]/30 rounded-2xl px-4 py-3 shadow-lg">
                  <p className="text-[#1a1a1a] text-sm font-semibold" style={{ fontFamily: 'DM Sans, sans-serif' }}>Dra. Leonida Hendges Fontoura</p>
                  <p className="text-[#C9A84C] text-xs mt-0.5 font-medium" style={{ fontFamily: 'DM Sans, sans-serif' }}>CRM RS: 58689 | CRM SC: 43471</p>
                </div>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="flex-1 flex flex-col justify-center">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1a1a1a] leading-tight mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
              Referência em<br />
              <span className="italic text-[#C9A84C]">Remodelação</span><br />
              Glútea
            </h2>

            <p className="text-[#666] text-sm sm:text-base leading-relaxed mb-5" style={{ fontFamily: 'DM Sans, sans-serif' }}>
              Especialista em procedimentos avançados para remodelação glútea, contorno corporal, emagrecimento e performance. Cada tratamento é pensado de forma personalizada, respeitando a anatomia, a individualidade e os objetivos de cada paciente.
            </p>

            <p className="text-[#666] text-sm sm:text-base leading-relaxed mb-8" style={{ fontFamily: 'DM Sans, sans-serif' }}>
              Com abordagem estratégica e técnica refinada, a Dra. Leonida valoriza não apenas a estética, mas também a saúde, o bem-estar, a autoestima e a sustentação dos resultados ao longo do tempo.
            </p>

            {/* Divider */}
            <div className="w-full h-px bg-[#e8dfc8] mb-8"></div>

            {/* Location cards */}
            <div className="flex flex-col sm:flex-row gap-4">
              <div className="flex-1 bg-white border border-[#e8dfc8] rounded-2xl px-5 py-4 shadow-sm hover:shadow-md hover:border-[#C9A84C]/40 transition-all duration-300">
                <div className="w-8 h-8 flex items-center justify-center mb-3">
                  <i className="ri-map-pin-2-line text-[#C9A84C] text-xl"></i>
                </div>
                <p className="text-[#1a1a1a] text-sm font-semibold mb-0.5" style={{ fontFamily: 'DM Sans, sans-serif' }}>Atendimentos</p>
                <p className="text-[#999] text-xs" style={{ fontFamily: 'DM Sans, sans-serif' }}>RS e SC</p>
              </div>
              <div className="flex-1 bg-white border border-[#e8dfc8] rounded-2xl px-5 py-4 shadow-sm hover:shadow-md hover:border-[#C9A84C]/40 transition-all duration-300">
                <div className="w-8 h-8 flex items-center justify-center mb-3">
                  <i className="ri-building-4-line text-[#C9A84C] text-xl"></i>
                </div>
                <p className="text-[#1a1a1a] text-sm font-semibold mb-0.5" style={{ fontFamily: 'DM Sans, sans-serif' }}>Clínica</p>
                <p className="text-[#999] text-xs" style={{ fontFamily: 'DM Sans, sans-serif' }}>Clínica Floratta</p>
              </div>
              <div className="flex-1 bg-white border border-[#e8dfc8] rounded-2xl px-5 py-4 shadow-sm hover:shadow-md hover:border-[#C9A84C]/40 transition-all duration-300">
                <div className="w-8 h-8 flex items-center justify-center mb-3">
                  <i className="ri-award-line text-[#C9A84C] text-xl"></i>
                </div>
                <p className="text-[#1a1a1a] text-sm font-semibold mb-0.5" style={{ fontFamily: 'DM Sans, sans-serif' }}>Pacientes</p>
                <p className="text-[#999] text-xs" style={{ fontFamily: 'DM Sans, sans-serif' }}>+2.000 atendidas</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}